import { StudioVisualizationType } from '@blockworks/platform/api/research/studio';

import { makeGetParameters, makeParameterGroupMeta } from '../utils';

const getTableParameters = makeGetParameters([makeParameterGroupMeta])<StudioVisualizationType.Table>;

export { getTableParameters };
